import script from "./Index.vue?vue&type=script&setup=true&lang=js"
export * from "./Index.vue?vue&type=script&setup=true&lang=js"

import "./Index.vue?vue&type=style&index=0&id=3b975b8d&lang=less&scoped=true"
script.__scopeId = "data-v-3b975b8d"

export default script